import { computed } from 'vue-demi';
const {
    rem: { rem }
} = require('@futuweb/fego-bridge');
const { usePageType } = require('@fegobull/webapi').use;

export function useCssProperties(props) {
    const { isPC } = usePageType();
    const cssProperties = computed(() => {
        return {
            '--tab-background-color': props.tpl.style.backgroundColor,
            '--tab-header-height': rem.str(props.tpl.props.headerHeight),
            '--tab-header-line-height': rem.str(props.tpl.props.headerHeight),
            '--tab-header-max-height': rem.str(props.tpl.props.headerHeight),
            // '--tab-header-padding-top-bottom': rem.str(props.tpl.props.headerHeight / 2),
            '--tab-header-margin-right': rem.str(props.tpl.props.headerMargin),
            '--tab-header-margin-left': rem.str(props.tpl.props.headerMargin),
            '--tab-header-padding': isPC ? '.4rem' : '.2rem',
            '--tab-header-font-size': rem.str(props.tpl.props.headerFontSize),
            '--tab-header-font-family': props.tpl.props.headerFontFamily,
            '--tab-header-font-color': props.tpl.props.headerFontColor,
            '--tab-header-font-active-weight': 500,
            '--tab-header-font-active-color': props.tpl.props.headerActiveColor,
            '--tab-header-font-long-bar-color': props.tpl.props.headerLongBarColor,
            '--tab-header-active-bar-color': props.tpl.props.headerBarColor,
            '--tab-header-just-content': props.tpl.props.headerJustifyContent,
            '--tab-header-first-or-last-margin': '0px'
            // '--tab-header-first-or-last-margin': ['left', 'right'].includes(props.tpl.props.headerJustifyContent)
            //     ? '0px'
            //     : rem.str(props.tpl.props.headerMargin)
        };
    });
    return {
        cssProperties
    };
}
